import React from "react";

import { QuickAddBase } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/QuickAdd/QuickAddBase";
import { QuickAddProps } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/QuickAdd/QuickAddProps";
import { QuickAddTrackingEventsContextProvider } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/QuickAdd/QuickAddTrackingEventsContext/QuickAddTrackingEventsContextProvider";
import { DeferRenderedQuickAdd } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/QuickAdd/Search/DeferRenderedQuickAdd";
import { MaybePersistQuickAddOnSearch } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/QuickAdd/Search/MaybePersistQuickAddOnSearch";

import { ComponentDisplayOnHoverContainer } from "../../ComponentDisplayOnHoverContainer";

export const QuickAdd = ({
  data,
  showOnHover,
}: {
  data: QuickAddProps;
  showOnHover: boolean;
}) => {
  return (
    <MaybePersistQuickAddOnSearch
      showOnHover={showOnHover}
      hoverQuickAdd={
        <ComponentDisplayOnHoverContainer key={data.productToken ?? ""}>
          <QuickAddTrackingEventsContextProvider data={data}>
            <QuickAddBase data={data} />
          </QuickAddTrackingEventsContextProvider>
        </ComponentDisplayOnHoverContainer>
      }
      nonHoverQuickAdd={<DeferRenderedQuickAdd data={data} />}
    />
  );
};
